import { axios, path } from './config';
import { ONE, pageNum } from 'appConstants';

export function claimJobChat({ jobChatUuid, chatId }) {
  const params = {
    jobchat_uuid: jobChatUuid,
    id: chatId,
  };

  return axios.get(path.CLAIM_JOB_CHAT, { params });
}

export function getChatAgents({ customerId, teamId, ...filters }) {
  const { page = ONE, itemsPerPage = pageNum.HUNDRED } = filters;

  const params = {
    team_id: teamId,
  };

  if (customerId) {
    params.customer_id = customerId;
  }

  params.page = page;
  params.items_per_page = itemsPerPage;

  return axios.get(path.GET_CHAT_AGENTS, { params });
}

export function getActiveChats({
  pageNumber = pageNum.ONE,
  itemsPerPage = pageNum.THIRTY,
  filters = [],
}) {
  const params = {
    page: pageNumber,
    filter: JSON.stringify(filters),
    items_per_page: itemsPerPage,
  };

  return axios.get(path.GET_ACTIVE_CHATS, { params });
}
